<template>
    <div></div>
</template>

<script>
import store from '@/store';
import router from '@/router';
import { routers } from '@/router/routerView';
import { eventBus } from '@/common/eventBus.ts';
export default {
    name: '',
    components: {},
    props: {},
    data() {
        return {
            localVersion: '1.0.0.90',
            reConnectTimes: 0,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.initPage();
    },
    mounted() {},
    destroyed() { },
    methods: {
        async initPage() {
            let type = '';
            // const token = 'Bearer BC98CD6C4B32583B449703C374E9B386D1E2B3E4D56BFB0539539F24B33356FD';
            // localStorage.setItem('token', token);
            // const identityType = 1;
            // const approvalProcess = '';
            // const user_type = '2';

            // 用户信息
            const userInfo = await this.getUserInfo();
            // 保存版本标识[1普通版本，2高级版]
            store.commit('setVersionMark', userInfo.AuthorizationVersion);
            const newInfo = encodeURI(JSON.stringify(userInfo));
            sessionStorage.setItem('userInfo', newInfo);


            const user_type = this.$takeTokenParameters('User_Type');
            const identityType = window.localStorage.getItem('identityType');
            const approvalProcess = window.localStorage.getItem('approvalProcess');
            /**
             * identityType 菜单类型
             * = 1 【应用】
             * = 2 【通讯录】
             * = 3 【关于我们】
             * = 4 【系统通知】
             * = 5 【合同审批通知】
             *
             *
             * * user_type  用户类别
             * = 1  【销售端】
             * = 2  【司机端】
             * = 3  【客户端】
             * = 4  【供应商】
             * = 5  【运输单位】
             */
            if (identityType) {
                if (Number(identityType) === 1 || Number(identityType) === 5) {
                    if (user_type === '1') {
                        type = 40;
                    } else if (user_type === '2') {
                        type = 2;
                    } else if (user_type === '3') {
                        type = 3;
                    } else if (user_type === '4') {
                        type = 4;
                    } else if (user_type === '5') {
                        type = 5;
                    }
                } else if (Number(identityType) === 2) {
                    type = 'addressList';
                } else if (Number(identityType) === 3) {
                    type = 'my';
                } else if (Number(identityType) === 4) {
                    type = 'systemNotification';
                } else {
                    type = user_type;
                }
            }
            let addRouters = [];
            routers.forEach(item => {
                if (type !== 'addressList' && type !== 'my' && type !== 'systemNotification') {
                    if (Number(type) === item.name) {
                        addRouters = item.router;
                    }
                } else if (type === item.name) {
                    addRouters = item.router;
                }
            });

            if (addRouters.length > 0) {
                addRouters.push({
                // 缺省页
                    path: '/error',
                    name: 'error',
                    component: () => import('@/views/default/error.vue'),
                });
                addRouters.push({
                    path: '*',
                    redirect: '/error',
                });
                router.addRoutes(addRouters);
                // 临时改动ios特殊处理
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) && type === 10) {
                    this.$router.replace({ path: 'home' });
                } else if (Number(identityType) === 5) {
                    if (approvalProcess) {
                        const pageData = JSON.parse(approvalProcess);
                        this.$router.replace({
                            name: pageData.path,
                            params: {
                                data: pageData.data,
                                isNews: true,
                            },
                        });
                    }
                } else {
                    this.$router.replace({ path: 'home' });
                }
            }

            // 判断版本是否刷新webview
            this.getWebAppVersion();
            this.handleSignlarMsg();
        },

        handleSignlarMsg() {
            /* 连接signlar */
            const signalrToken = localStorage.getItem('token').split(' ')[1];
            const signalR = require('../../public/signalr/signalr.min');
            const connection = new signalR.HubConnectionBuilder().withUrl('/interfaceApi/signalr/signalRHubClientService', {
                accessTokenFactory: () => signalrToken,
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets,
            }).build();
            const that = this;
            connection.on('ReceiveMessage', function (data) {
                if (data.phone === that.$takeTokenParameters('MobilePhone')) {
                    eventBus.$emit('toCarOrder');
                    eventBus.$emit('driverPcb');
                }
                // 更新排队列表
                eventBus.$emit('vehicleQueuePush');
            });
            // 禁用，退出登录
            connection.on('UserLoginOutMessage', function (data) {
                const dat = JSON.parse(data);
                if (dat.TenantId === that.$takeTokenParameters('TenantId') && dat.LogonRights.indexOf('2') === -1) {
                    that.$dialog({ message: '登录状态已过期，请重新登录！' });
                    setTimeout(() => {
                        localStorage.removeItem('token');
                        localStorage.removeItem('refreshToken');
                        that.$callMobile('JYTeamsNative', 'jyLogout');
                    }, 2000);
                }
            });
            // 车辆状态改变
            connection.on('TankCarStatusChangeMessage', function (data) {
                if (data.driver_phone === that.$takeTokenParameters('MobilePhone')) {
                    if (data.car_status === 21) {
                        // 车辆排队-已派单状态自动跳转到接单界面
                        eventBus.$emit('toCarOrder');
                        // eventBus.$emit('driverPcb');
                    } else if (data.car_status === 6) {
                        // 生产排车-扫一扫打料后，接料完毕（过磅出厂识别后）时，自动跳转到导航界面
                        eventBus.$emit('toNavigation');
                        // eventBus.$emit('driverPcb');
                    } else if (data.car_status === 1) {
                        // 生产排车-进场-刷新排车列表
                        // eventBus.$emit('driverPcb');
                    }
                    let pcb_number = localStorage.getItem('pcb_number');
                    if (typeof pcb_number === 'undefined' || pcb_number === null) {
                        pcb_number = '';
                    }
                    if (pcb_number !== data.pcb_number) {
                        eventBus.$emit('driverPcb');
                        if (!data.pcb_number) {
                            localStorage.setItem('pcb_number', data.pcb_number);
                        }
                    } else if (data.pcb_number) {
                        const arr = [1, 2, 21, 4, 5, 6, 7];
                        // eslint-disable-next-line radix
                        if (arr.indexOf(parseInt(data.car_status)) !== -1) {
                            // eslint-disable-next-line radix
                            if (parseInt(localStorage.getItem('currentOrderStatus')) !== parseInt(data.car_status)) {
                                eventBus.$emit('driverPcb');
                            }
                        }
                    }
                }
                eventBus.$emit('Monitoring', JSON.stringify(data));
            });
            // 车辆状态改变
            connection.on('MapCarChangeMessage', function (obj) {
                if (obj !== null) {
                    eventBus.$emit('MapCarChangeMsg', JSON.parse(obj));
                }
            });
            // 换车
            connection.on('TankCarChangeMessage', function (data) {
                if (data.driver_phone === that.$takeTokenParameters('MobilePhone')) {
                    eventBus.$emit('driverPcb');
                }
            });
            // 车辆位置
            connection.on('CoordinateMessage', function (data) {
                eventBus.$emit('CoordinateMessage', JSON.stringify(data));
            });
            // 车辆设备变化
            connection.on('IntervalChangeMessage', async function (data) {
                const parseData = JSON.parse(data);
                const res = await that.getCarByPhone();
                if (res.plate_number === parseData.CarLicense) {
                    that.$callMobile('JYExternalNative', 'jyVehicleChangeEvent', parseData);
                }
            });
            // 冻结消息
            connection.on('TankCarFrozenMessage', function (data) {
                if (data.phone === that.$takeTokenParameters('MobilePhone')) {
                    eventBus.$emit('frozenOrder', data);
                }
            });
            connection.start().then(function () {
                // console.log('连接signlar成功！');
                const uid = that.$takeTokenParameters('Uid');
                connection.invoke('AddConnRelation', uid).catch(() => {
                    // return console.error(err.toString());
                });
                const user_type = that.$takeTokenParameters('User_Type');
                // 如果是司机端
                if (Number(user_type) === 2) {
                    const tenantId = that.$takeTokenParameters('TenantId');
                    let groupName = tenantId + '-TANK_CAR_DRIVER';
                    connection.invoke('AddToGroup', groupName).catch(function () {
                        // console.error(err.toString());
                    });
                    groupName = tenantId + '-PRODUCTION_DELIVERY';
                    connection.invoke('AddToGroup', groupName).catch(function () {
                        // console.error(err.toString());
                    });
                }
            }).catch(function (err) {
                alert(err.toString());
            });
            connection.onclose(() => {
                if (this.reConnectTimes <= 5) {
                    this.reConnectTimes++;
                    this.handleSignlarMsg();
                }
            });
        },
        // 通过手机号查询车辆信息
        getCarByPhone() {
            return this.$axios.get(`/interfaceApi/production/vehicleinfo/get_vehicle_driver?phone=${this.$takeTokenParameters('MobilePhone')}`);
        },
        // 获取WebApp新版本信息
        getWebAppVersion() {
            this.$axios.get('/interfaceApi/tenant/mobile/get_webapp/' + this.localVersion)
                .then(res => {
                    if (res) {
                        if (this.localVersion && res.version) {
                            const localVersion = Number(this.localVersion.split('.').join(''));
                            const dataVersion = Number(res.version.split('.').join(''));
                            // 如果本地版本小于线上版本则刷新webview
                            if (localVersion < dataVersion) {
                                this.$callMobile('JYExternalNative', 'reloadWebView');
                            }
                        }
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },

        // 获取用户信息
        getUserInfo() {
            return this.$axios.$get('interfaceApi/auth/connect/userinfo', { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
</style>
